import styled from 'styled-components';
import { Box, Theme } from '@material-ui/core';
import { theme } from '../utils/theme';

export const DataHeader = styled(Box)(props => ({
  margin: 0,
  paddingBottom: theme(props).spacing(2),
  paddingTop: theme(props).spacing(2),
  paddingLeft:theme(props).spacing(4),
  paddingRight: theme(props).spacing(4),
  display: 'flex',
  height: theme(props).spacing(6.25),
  boxSizing: 'content-box',
  justifyContent: 'flex-start',
})) as typeof Box;